import { render, staticRenderFns } from "./testItem.vue?vue&type=template&id=11b3e96f&scoped=true&"
import script from "./testItem.vue?vue&type=script&lang=js&"
export * from "./testItem.vue?vue&type=script&lang=js&"
import style0 from "./testItem.vue?vue&type=style&index=0&id=11b3e96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3e96f",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/testItem.vue
// module id = null
// module chunks = 